(() => {
  const roots = document.querySelectorAll('[data-catalog-downloads]');
  roots.forEach((root) => {
    const filters = root.querySelectorAll('[data-catalog-filter]');
    const cards = root.querySelectorAll('[data-catalog-card]');
    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const category = filter.dataset.catalogFilter;
        filters.forEach((item) => {
          const active = item === filter;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        cards.forEach((card) => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
        });
      });
    });
  });
})();
